<div class="filter-bar" [formGroup]="filterForm">

  <!-- ── Search row ───────────────────────────────────────────────────────── -->
  @if (config.search) {
    <div class="search-row">
      <mat-form-field appearance="outline" class="search-field">
        <mat-icon matPrefix aria-hidden="true">search</mat-icon>
        <input matInput formControlName="search" [placeholder]="searchPlaceholder" (keydown.enter)="apply()" />
        @if (filterForm.controls.search.value) {
          <button matSuffix mat-icon-button type="button" (click)="clearControl('search')" aria-label="Clear search">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    </div>
  }

  <!-- ── Filter row ───────────────────────────────────────────────────────── -->
  <div class="filter-row">

    <!-- Category (multi-select, grouped by vertical when verticals present) -->
    @if (config.categories) {
      <mat-form-field appearance="outline" class="filter-field">
        <mat-select formControlName="categoryIds" placeholder="Category" multiple panelClass="categories-panel" (closed)="apply()">
          @if (hasGroups()) {
            @for (group of categoriesByVertical(); track group.label) {
              <mat-optgroup [label]="group.label">
                @for (cat of group.options; track cat.id) {
                  <mat-option [value]="cat.id">{{ cat.name }}</mat-option>
                }
              </mat-optgroup>
            }
          } @else {
            @for (cat of _categoryOptions(); track cat.id) {
              <mat-option [value]="cat.id">{{ cat.name }}</mat-option>
            }
          }
        </mat-select>
        @if (filterForm.controls.categoryIds.value.length) {
          <button matSuffix mat-icon-button type="button" class="clear-btn"
                  (click)="$event.stopPropagation(); clearControl('categoryIds')"
                  aria-label="Clear category">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }

    <!-- City codes — flat list (providers) -->
    @if (config.cityCodes) {
      <mat-form-field appearance="outline" class="filter-field">
        <mat-select formControlName="cityCodes" placeholder="City" multiple panelClass="filter-panel" (closed)="apply()">
          @for (city of _cityOptions(); track city.code) {
            <mat-option [value]="city.code">{{ city.label }}</mat-option>
          }
        </mat-select>
        @if (filterForm.controls.cityCodes.value.length) {
          <button matSuffix mat-icon-button type="button" class="clear-btn"
                  (click)="$event.stopPropagation(); clearControl('cityCodes')"
                  aria-label="Clear city">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }

    <!-- City availability — multi-select (service categories) -->
    @if (config.cityAvailability) {
      <mat-form-field appearance="outline" class="filter-field">
        <mat-select formControlName="cityAvailability" placeholder="City" multiple panelClass="filter-panel" (closed)="apply()">
          @for (city of _cityOptions(); track city.code) {
            <mat-option [value]="city.code">{{ city.label }}</mat-option>
          }
        </mat-select>
        @if (filterForm.controls.cityAvailability.value.length) {
          <button matSuffix mat-icon-button type="button" class="clear-btn"
                  (click)="$event.stopPropagation(); clearControl('cityAvailability')"
                  aria-label="Clear city">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }

    <!-- Vertical -->
    @if (config.vertical) {
      <mat-form-field appearance="outline" class="filter-field">
        <mat-select formControlName="vertical" placeholder="Vertical" panelClass="filter-panel" (closed)="apply()">
          @for (opt of _verticalOptions(); track opt.value) {
            <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
          }
        </mat-select>
        @if (filterForm.controls.vertical.value) {
          <button matSuffix mat-icon-button type="button" class="clear-btn"
                  (click)="$event.stopPropagation(); clearControl('vertical')"
                  aria-label="Clear vertical">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }

    <!-- Trust status -->
    @if (config.trustStatus) {
      <mat-form-field appearance="outline" class="filter-field">
        <mat-select formControlName="trustStatus" placeholder="Trust status" panelClass="filter-panel" (closed)="apply()">
          @for (opt of TRUST_OPTIONS; track opt.value) {
            <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
          }
        </mat-select>
        @if (filterForm.controls.trustStatus.value) {
          <button matSuffix mat-icon-button type="button" class="clear-btn"
                  (click)="$event.stopPropagation(); clearControl('trustStatus')"
                  aria-label="Clear trust status">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }

    <!-- Insurance verified -->
    @if (config.insuranceVerified) {
      <mat-form-field appearance="outline" class="filter-field">
        <mat-select formControlName="insuranceVerified" placeholder="Insurance" panelClass="filter-panel" (closed)="apply()">
          <mat-option value="true">Verified</mat-option>
          <mat-option value="false">Not verified</mat-option>
        </mat-select>
        @if (filterForm.controls.insuranceVerified.value) {
          <button matSuffix mat-icon-button type="button" class="clear-btn"
                  (click)="$event.stopPropagation(); clearControl('insuranceVerified')"
                  aria-label="Clear insurance filter">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }

    <!-- Status (isActive) -->
    @if (config.isActive) {
      <mat-form-field appearance="outline" class="filter-field">
        <mat-select formControlName="isActive" placeholder="Status" panelClass="filter-panel" (closed)="apply()">
          <mat-option value="true">Active</mat-option>
          <mat-option value="false">Inactive</mat-option>
        </mat-select>
        @if (filterForm.controls.isActive.value) {
          <button matSuffix mat-icon-button type="button" class="clear-btn"
                  (click)="$event.stopPropagation(); clearControl('isActive')"
                  aria-label="Clear status filter">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }

    <!-- Reset -->
    @if (hasApplied()) {
      <button type="button" class="reset-btn" (click)="reset()">Reset</button>
    }

  </div>

</div>